import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { Pencil, Check, X } from "lucide-react"; // <-- ZMIANA TUTAJ
import axios from "axios";

const EditWrapper = styled.div`
  position: relative;
  display: inline-block;
  width: 100%;
  
  &:hover .edit-overlay {
    opacity: 1;
  }
`;

const EditOverlay = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  background: rgba(0,0,0,0.7);
  color: white;
  padding: 8px;
  cursor: pointer;
  opacity: 0;
  transition: opacity 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
`;

const EditorInput = styled.textarea`
  width: 100%;
  font-family: inherit;
  font-size: inherit;
  font-weight: inherit;
  color: inherit;
  background: #f9f9f9;
  border: 2px dashed #ccc;
  padding: 10px;
  min-height: 80px;
`;
export const EditableText = ({ textId, defaultText, children }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [content, setContent] = useState(defaultText);
  const [savedContent, setSavedContent] = useState(defaultText);
  
  // SPRAWDZANIE CZY UŻYTKOWNIK JEST ADMINEM
  const isAdmin = !!localStorage.getItem("adminToken");

  useEffect(() => {
    axios.get(`https://api.pth-hokej.pl/api/teksty/${textId}`)
      .then(res => {
        if (res.data && res.data.tresc) {
          setContent(res.data.tresc);
          setSavedContent(res.data.tresc);
        }
      })
      .catch(() => console.log("Brak tekstu w bazie, używam domyślnego"));
  }, [textId]);

  const handleSave = async () => {
    const token = localStorage.getItem("adminToken");
    try {
      await axios.put(`https://api.pth-hokej.pl/api/teksty/${textId}`, 
        { tresc: content },
        { headers: { Authorization: `Bearer ${token}` } } // Autoryzacja zapisu
      );
      setSavedContent(content);
      setIsEditing(false);
    } catch (error) {
      alert("Błąd zapisu! Sesja mogła wygasnąć.");
    }
  };

  if (isEditing && isAdmin) {
    return (
      <div style={{ width: '100%', marginBottom: '10px' }}>
        <EditorInput value={content} onChange={(e) => setContent(e.target.value)} />
        <div style={{ display: 'flex', gap: '10px', marginTop: '5px' }}>
          <button onClick={handleSave} style={{ background: '#28a745', color: '#fff', padding: '8px 12px', border: 'none', cursor: 'pointer', borderRadius: '4px', display: 'flex', alignItems: 'center', gap: '5px' }}><Check size={16}/> Zapisz</button>
          <button onClick={() => { setIsEditing(false); setContent(savedContent); }} style={{ background: '#dc3545', color: '#fff', padding: '8px 12px', border: 'none', cursor: 'pointer', borderRadius: '4px', display: 'flex', alignItems: 'center', gap: '5px' }}><X size={16}/> Anuluj</button>
        </div>
      </div>
    );
  }

  return (
    <EditWrapper>
      {/* OŁÓWEK POKAZUJE SIĘ TYLKO ADMINOWI */}
      {isAdmin && (
        <EditOverlay className="edit-overlay" onClick={() => setIsEditing(true)}>
          <Pencil size={16} />
        </EditOverlay>
      )}
      {React.cloneElement(children, {}, savedContent)}
    </EditWrapper>
  );
};